import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { normalizeBuildingType } from './ufAttributeFormUtils';

/** Íconos por tipo de inmueble — compartidos entre empty state, lista UF y wizard. */
export const UF_BUILDING_TYPE_ICON_MAP = {
  casa: HomeOutlinedIcon,
  departamento: ApartmentOutlinedIcon,
  ph: HomeWorkOutlinedIcon,
  duplex: HomeWorkOutlinedIcon,
  comercio: StorefrontOutlinedIcon,
};

/** Fallback: icono “casa + edificio” (no el de casa sola). */
export const DEFAULT_UF_BUILDING_TYPE_ICON = HomeWorkOutlinedIcon;

export const UF_BUILDING_TYPE_EMPTY_STATE_ICONS = [
  HomeOutlinedIcon,
  ApartmentOutlinedIcon,
  StorefrontOutlinedIcon,
];

export function getUfBuildingTypeIcon(buildingType) {
  const rawKey = String(buildingType ?? '').trim().toLowerCase();
  if (rawKey && UF_BUILDING_TYPE_ICON_MAP[rawKey]) {
    return UF_BUILDING_TYPE_ICON_MAP[rawKey];
  }

  const normalized = normalizeBuildingType(buildingType);
  if (normalized && UF_BUILDING_TYPE_ICON_MAP[normalized]) {
    return UF_BUILDING_TYPE_ICON_MAP[normalized];
  }

  return DEFAULT_UF_BUILDING_TYPE_ICON;
}

export const UF_BUILDING_TYPE_ICON_SX = {
  width: 32,
  height: 26,
  color: '#E8F4F4',
  position: 'relative',
  top: '3px',
};

export const UF_BUILDING_TYPE_ICON_TILE_SX = {
  width: 60,
  height: 60,
  borderRadius: '8px',
  bgcolor: '#242424',
  border: '1px solid rgba(255,255,255,0.08)',
  boxSizing: 'border-box',
  p: '14px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

/** Variante compacta para filas de lista. */
export const UF_BUILDING_TYPE_ICON_TILE_LIST_SX = {
  ...UF_BUILDING_TYPE_ICON_TILE_SX,
  width: 44,
  height: 44,
  p: '10px',
};

export const UF_BUILDING_TYPE_ICON_LIST_SX = {
  width: 24,
  height: 20,
  color: '#E8F4F4',
  position: 'relative',
  top: '2px',
};
